// extracted by mini-css-extract-plugin
module.exports = {"switcher":"switcher_switcher__nXCMB"};